module.exports = __webpack_public_path__ + "static/img/3.73d70f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/3.png
// module id = 2KbQ
// module chunks = 0